import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { handleApiError } from '@/utils/apiErrorHandler';
import { clearError } from './errorSlice';

export const fetchNews = createAsyncThunk('news/fetchNews', async (query: { [key: string]: string }, { dispatch, rejectWithValue }) => {
  try {
    dispatch(clearError());
    const response = await axios.get(`/api/content/news`, { params: query });
    return response.data;
  } catch (error) {
    handleApiError(error as AxiosError, "news", dispatch);
    return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch news');
  }
});

const newsSlice = createSlice({
  name: 'news',
  initialState: {
    articles: [],
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNews.fulfilled, (state, action) => {
        state.loading = false;
        state.articles = action.payload.articles;
      })
      .addCase(fetchNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Unknown error';
      });
  },
});

export default newsSlice.reducer;